/*
 * Copyright (c) 2025 Ipivot Corporation.
 * All rights reserved.
 * This software is the confidential and proprietary information of
 *  Ipivot Corporation ("Confidential Information").
 */
'use strict'
import Form from 'react-bootstrap/Form';
import { Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { useState, useEffect, useContext } from 'react';
import { getProbeTypes, purgeProbe } from '../data';
import { StatusContext, StatusContextType } from './StatusContext';

function PurgeProbeModal({show, setShow}: {show: boolean, setShow: (show: boolean) => void}) {
    const [ typeToDelete, setTypeToDelete ] = useState<string>("ALL");
    const [ queueStatusToDelete, setQueueStatusToDelete ] = useState<string>("PEND");
    const [probeTypes, setProbeTypes] = useState<string[]>([]);
    const statusContext = useContext(StatusContext) as StatusContextType;

    useEffect(() => {
        const fetchProbeTypes = async () => {
            try {
                const types = await getProbeTypes();
                setProbeTypes(types);
            } catch (err) {
                console.error('Error fetching probe types:', err);
                statusContext.postError(`Error fetching probe types: ${err.message}`);
            }
        };
        
        if (show) {
            fetchProbeTypes();
        }
    }, [show]);
    
    function doPurge() {
        async function dodoPurge() {
            try {
                const count = await purgeProbe(typeToDelete, queueStatusToDelete);
                console.log(`Successfully purged ${count} probes of type ${typeToDelete}`);
                // Use postError for success message too as there's no postSuccess method
                statusContext.postError(`Successfully purged ${count} probes type=${typeToDelete} status=${queueStatusToDelete}`);
            } catch (error) {
                console.error('Error purging probes:', error);
                statusContext.postError(`Error purging probes: ${error.message}`);
            }
        }
        dodoPurge();
    }

    return (
        <Modal show={show} onHide={() => { setShow(false); }}>
            <Modal.Header closeButton>
                <Modal.Title>Purge Probes</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                This will permanently delete probes from the system. Select a probe type or "all" to purge all probes.
            <Form>
                <Form.Group className="mb-3">
                    <Form.Label>Probe Type</Form.Label>
                    <Form.Select 
                        value={typeToDelete} 
                        onChange={(e) => setTypeToDelete(e.target.value)}
                    >
                        <option value="ALL">All</option>
                        {probeTypes.map((type, index) => (
                            <option key={index} value={type}>{type}</option>
                        ))}
                    </Form.Select>
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Queue Status</Form.Label>
                    <Form.Select 
                        value={queueStatusToDelete} 
                        onChange={(e) => setQueueStatusToDelete(e.target.value)}
                    >
                        <option value="queued">Queued</option>
                        <option value="complete">Complete</option>
                        <option value="all">All</option>
                    </Form.Select>
                </Form.Group>
            </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => { setShow(false); }}>
                    Cancel
                </Button>
                <Button variant="danger" onClick={() => { 
                    setShow(false);
                    doPurge();
                }}>
                    Purge Probes
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default PurgeProbeModal;